module.exports = __webpack_public_path__ + "assets/img/cloud6.0ad44ce0.png";